import React, { useState, useEffect } from 'react';
import {
  Grid,
  Typography,
  Box,
  Switch,
  Button,
  Card,
  CardContent,
} from '@mui/material';
import { useGetSettingsQuery, useUpdateSettingsMutation } from 'state/api';
import { useSnack, SaveSnackbar } from './settingsHelper';

const PaymentOptions = () => {
  const { data } = useGetSettingsQuery();
  const settings = data?.data || {};
  const [updateSettings, { isLoading }] = useUpdateSettingsMutation();
  const { snack, showSuccess, showError, closeSnack } = useSnack();

  const [cashOnDelivery, setCashOnDelivery] = useState(true);
  const [digitalPayment, setDigitalPayment] = useState(true);
  const [offlinePayment, setOfflinePayment] = useState(true);

  useEffect(() => {
    const p = settings.custom?.paymentOptions;
    if (!p) return;
    if (p.cashOnDelivery !== undefined) setCashOnDelivery(p.cashOnDelivery);
    if (p.digitalPayment !== undefined) setDigitalPayment(p.digitalPayment);
    if (p.offlinePayment !== undefined) setOfflinePayment(p.offlinePayment);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleCashOnDeliveryChange = (event) => {
    setCashOnDelivery(event.target.checked);
  };

  const handleDigitalPaymentChange = (event) => {
    setDigitalPayment(event.target.checked);
  };

  const handleOfflinePaymentChange = (event) => {
    setOfflinePayment(event.target.checked);
  };

  const handleSave = async () => {
    try {
      await updateSettings({
        custom: { paymentOptions: { cashOnDelivery, digitalPayment, offlinePayment } },
      }).unwrap();
      showSuccess();
    } catch (err) {
      showError(err?.data?.error?.message);
    }
  };

  return (
    <Card variant="outlined" sx={{ borderColor: 'divider', bgcolor: 'background.paper' }}>
      <CardContent>
        <Typography variant="h6" color="text.primary" sx={{ mb: 2 }}>
          Payment Methods
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="body1" color="text.primary">Cash on Delivery</Typography>
              <Switch checked={cashOnDelivery} onChange={handleCashOnDeliveryChange} />
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="body1" color="text.primary">Digital Payment</Typography>
              <Switch checked={digitalPayment} onChange={handleDigitalPaymentChange} />
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="body1" color="text.primary">Offline Payment</Typography>
              <Switch checked={offlinePayment} onChange={handleOfflinePaymentChange} />
            </Box>
          </Grid>
        </Grid>
        <Box sx={{ mt: 2, textAlign: 'right' }}>
          <Button variant="contained" color="primary" onClick={handleSave} disabled={isLoading}>
            {isLoading ? 'Saving...' : 'Save'}
          </Button>
        </Box>

        <SaveSnackbar snack={snack} onClose={closeSnack} />
      </CardContent>
    </Card>
  );
};

export default PaymentOptions;
